import {bootstrapApp} from './app/app.bootstrap';

// Vstup pro development / local / production. Mock backend (MSW worker) a MSW toolbar mají
// vlastní vstup `src/main.mock.ts` (konfigurace `mock`), aby se do ostatních buildů vůbec
// nedostaly — ani jako lazy chunk, který by service worker prefetchoval všem uživatelům.
bootstrapApp().catch(err => console.error(err));
